class MicroChart {

    createDottedLineChart(chart, am4charts, am4core, data, title, selectedHorizantalField, selectedVerticalField) {
        chart.data = data;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = selectedHorizantalField;
        categoryAxis.renderer.minGridDistance = 60;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = title;
        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.categoryX = selectedHorizantalField;
        series.dataFields.valueY = selectedVerticalField;
        series.strokeWidth = 2;
        series.tooltipText = "{valueY}";
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.background.fillOpacity = 0.5;

        let bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.fill = am4core.color("#fff");
        bullet.circle.strokeWidth = 3;

        // Add cursor
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.fullWidthLineX = true;
        chart.cursor.lineX.strokeWidth = 0;
        chart.cursor.lineX.fill = am4core.color("#000");
        chart.cursor.lineX.fillOpacity = 0.1;
        chart.exporting.menu = new am4core.ExportMenu();

        return chart;
    }


    createSimpleLineChart(chart, am4charts, am4core, data, title, selectedHorizantalField, selectedVerticalField) {
        // Add data
        chart.data = data;

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = selectedHorizantalField;
        // categoryAxis.renderer.grid.template.location = 0;
        // categoryAxis.renderer.minGridDistance = 30;
        // categoryAxis.renderer.labels.template.horizontalCenter = "right";
        // categoryAxis.renderer.labels.template.verticalCenter = "middle";
        // categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        // categoryAxis.renderer.minHeight = 110;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = title;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = selectedVerticalField;
        series.dataFields.categoryX = selectedHorizantalField;
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
        chart.exporting.menu = new am4core.ExportMenu();
        return chart;
    }

    createVerticalLineChart(chart, am4charts, am4core, data, title, selectedHorizantalField, selectedVerticalField) {
        chart.padding(40, 40, 40, 40);

        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = selectedHorizantalField;
        categoryAxis.renderer.minGridDistance = 1;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.grid.template.disabled = true;

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.title.text = title;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = selectedHorizantalField;
        series.dataFields.valueX = selectedVerticalField;
        series.tooltipText = "{valueX.value}";
        series.columns.template.strokeOpacity = 0;
        series.columns.template.column.cornerRadiusBottomRight = 5;
        series.columns.template.column.cornerRadiusTopRight = 5;

        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.horizontalCenter = "left";
        labelBullet.label.dx = 10;
        labelBullet.label.text =
            "{values.valueX.workingValue.formatNumber('#.0as')}";
        labelBullet.locationX = 1;

        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", function (fill, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });

        categoryAxis.sortBySeries = series;
        chart.data = data;
        chart.exporting.menu = new am4core.ExportMenu();
        return chart;
    }

    createPieChart(chart, am4charts, am4core, data, selectedHorizantalField, selectedVerticalField) {
        // Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        chart.data = data;
        pieSeries.dataFields.value = selectedVerticalField;
        pieSeries.dataFields.category = selectedHorizantalField;
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        chart.hiddenState.properties.radius = am4core.percent(0);
        chart.exporting.menu = new am4core.ExportMenu();
        return chart;
    }

    create3DPieChart(chart, am4charts, am4core, data, selectedHorizantalField, selectedVerticalField) {
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.data = data;

        chart.innerRadius = am4core.percent(40);
        chart.depth = 120;

        let series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = selectedVerticalField;
        series.dataFields.depthValue = selectedVerticalField;
        series.dataFields.category = selectedHorizantalField;
        series.slices.template.cornerRadius = 5;
        series.colors.step = 3;
        chart.exporting.menu = new am4core.ExportMenu();
        return chart;
    }


    createDottedMultipleValueChart(chart, am4charts, am4core, data, selectedHorizantalField, selectedVerticalField, selectedRightField) {
        // Increase contrast by taking evey second color
        chart.colors.step = 2;

        // Add data
        chart.data = data;

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = selectedHorizantalField;
        categoryAxis.renderer.minGridDistance = 50;
        categoryAxis.renderer.grid.template.location = 0.5;
        categoryAxis.startLocation = 0.5;
        categoryAxis.endLocation = 0.5;

        // Create series
        this.createAxisAndSeries(
            selectedVerticalField,
            selectedVerticalField,
            false,
            "circle",
            chart,
            am4charts,
            am4core,
            selectedHorizantalField
        );
        this.createAxisAndSeries(
            selectedRightField,
            selectedRightField,
            true,
            "rectangle",
            chart,
            am4charts,
            am4core,
            selectedHorizantalField
        );

        // Add legend
        chart.legend = new am4charts.Legend();

        // Add cursor
        chart.cursor = new am4charts.XYCursor();
        return chart;
    }

    createAxisAndSeries(
        field,
        name,
        opposite,
        bulletType,
        chart,
        am4charts,
        am4core,
        selectedHorizantalField
    ) {
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        if (chart.yAxes.indexOf(valueAxis) !== 0) {
            valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
        }

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = selectedHorizantalField;
        series.strokeWidth = 2;
        series.yAxis = valueAxis;
        series.name = name;
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;

        let interfaceColors = new am4core.InterfaceColorSet();
        let bullet;
        switch (bulletType) {
            case "rectangle":
                bullet = series.bullets.push(new am4charts.Bullet());
                bullet.width = 10;
                bullet.height = 10;
                bullet.horizontalCenter = "middle";
                bullet.verticalCenter = "middle";

                let rectangle = bullet.createChild(am4core.Rectangle);
                rectangle.stroke = interfaceColors.getFor("background");
                rectangle.strokeWidth = 2;
                rectangle.width = 10;
                rectangle.height = 10;
                break;
            default:
                bullet = series.bullets.push(new am4charts.CircleBullet());
                bullet.circle.stroke = interfaceColors.getFor("background");
                bullet.circle.strokeWidth = 2;
                break;
        }

        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = opposite;
    }

    createLineMultipleValueChart(chart, am4charts, am4core, data, title, selectedHorizantalField, selectedVerticalField, selectedRightField) {
        chart.scrollbarX = new am4core.Scrollbar();

        // Add data
        chart.data = data;

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = selectedHorizantalField;
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 60;
        categoryAxis.tooltip.disabled = true;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.min = 0;
        valueAxis.title.text = title;
        valueAxis.cursorTooltipEnabled = false;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = selectedVerticalField;
        series.dataFields.categoryX = selectedHorizantalField;
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.fillOpacity = 0.7;
        series.columns.template.propertyFields.strokeDasharray = "dashLength";
        series.columns.template.propertyFields.fillOpacity = "alpha";
        series.showOnInit = true;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let paretoValueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        paretoValueAxis.renderer.opposite = true;
        paretoValueAxis.min = 0;
        paretoValueAxis.max = 100;
        paretoValueAxis.strictMinMax = true;
        paretoValueAxis.renderer.grid.template.disabled = true;
        paretoValueAxis.cursorTooltipEnabled = false;

        let paretoSeries = chart.series.push(new am4charts.LineSeries());
        paretoSeries.dataFields.valueY = selectedRightField;
        paretoSeries.dataFields.categoryX = selectedHorizantalField;
        paretoSeries.yAxis = paretoValueAxis;
        paretoSeries.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        paretoSeries.bullets.push(new am4charts.CircleBullet());
        paretoSeries.strokeWidth = 2;
        paretoSeries.stroke = new am4core.InterfaceColorSet().getFor(
            "alternativeBackground"
        );
        paretoSeries.strokeOpacity = 0.5;

        // Cursor
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "panX";

        return chart;
    }
}

export default MicroChart;
